import lfRequest from '@/service/index'

enum AccountApi {
  AccountInfo = '/main/employee/',
  GetMenu = '/main/employee/menu/',
  UpdatePassword = '/main/employee/password/',
  resetPassword = '/main/employee/resetPassword/',
  isResetPassword='/main/employee/getUserNeedChangePassword/'
}

export function requestAccountMenu(empNo: string) {
  return lfRequest.get<any>({
    url: AccountApi.GetMenu + empNo
  })
}

export function requestAccountByEmpNo(empNo: string) {
  return lfRequest.get<any>({
    url: AccountApi.AccountInfo + empNo
  })
}

export function updatePassword(id: string, queryInfo: any) {
  return lfRequest.put<any>({
    url: AccountApi.UpdatePassword + id,
    data: queryInfo
  })
}

export function resetPassword(id: string) {
  return lfRequest.put<any>({
    url: AccountApi.resetPassword + id
  })
}

// 查询用户是否修改密码
export function isResetPassword(empNo: string) {
  return lfRequest.get<any>({
    url: AccountApi.isResetPassword + empNo
  })
}